import { render } from "./OnboardingBox.vue?vue&type=template&id=5ffb8e72&scoped=true&ts=true"
import script from "./OnboardingBox.vue?vue&type=script&lang=ts"
export * from "./OnboardingBox.vue?vue&type=script&lang=ts"

import "./OnboardingBox.vue?vue&type=style&index=0&id=5ffb8e72&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffb8e72"]])

export default __exports__